import React from 'react';
import styled from 'styled-components';

import ControlledInput from './ControlledInput';
import ControlledSelectInput from './ControlledSelectInput';
import { commonStreetTypes, states } from '../GeoAddress/constants/address';

const ControlledManualAddressInput = ({
	toggleAddressInputModal,
	countryCode = 'AU',
}: {
	toggleAddressInputModal: () => void;
	countryCode: string;
}) => {
	return (
		<div>
			<div className=" _flex _flex-row">
				<StyledInput placeholder={'Unit No.'} name="unit_number" />
				<div style={{ width: 21 }} />
				<StyledInput placeholder={'Street No.'} name="street_number" />
			</div>
			<StyledInput placeholder={'Street Name'} name="street_name" />

			<StyledSelectInput options={commonStreetTypes} name="street_type" placeholder="Street Type" />
			<StyledInput placeholder={'City'} name="city" />
			<StyledSelectInput options={states[countryCode]} name="state" placeholder="State" />
			<StyledInput placeholder={'Post Code'} name="postcode" />

			<SubmitButton onClick={toggleAddressInputModal} style={{ height: 35, justifyContent: 'center' }}>
				<SubmitButtonText>Use Address Lookup</SubmitButtonText>
			</SubmitButton>
		</div>
	);
};
export default ControlledManualAddressInput;

const SubmitButton = styled.button({
	display: 'flex',
	height: 35,
	justifyContent: 'center',
});
const SubmitButtonText = styled.p({
	color: '#0081F3',
	fontWeight: '500',
});

const StyledInput = styled(ControlledInput)<{ hasBottomMargin?: boolean }>(({ hasBottomMargin = true }) => ({
	marginBottom: hasBottomMargin ? '20px' : 0,
}));

const StyledSelectInput = styled(ControlledSelectInput)<{ hasBottomMargin?: boolean }>(
	({ hasBottomMargin = true }) => ({
		marginBottom: hasBottomMargin ? '20px' : 0,
	})
);
